module.exports = __webpack_public_path__ + "static/media/vk-group-10-x.1a8d52e2.png";